import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"

import dayjs from "dayjs"
import utc from 'dayjs/plugin/utc'
import { LuCalendar } from "react-icons/lu"

dayjs.extend(utc)


const Calendar = ({
                    parentClassName,
                    width,
                    value,
                    onChange,
                    label,
                    isRequired,
                    disablePast = false,
                    timezone = "UTC",
                    disableFuture = false,
                    height,
                    calendarWidth,
                    weekendsDisabled = false,
                    disabled = false,
                    withLabel = true,
                    inputAndLabelDistance = 'mb-2',
                    optional = false,
                    errorMsg
                  }) => {
  const hasError = Boolean(errorMsg)
  // const createStylesByType = () => {
  //   const placeholderStyle = `placeholder:text-primary-gray-500`
  //   const defaultStyles = `py-2 h-10 py-4 px-3.5 text-primary-gray-950 text-lg font-normal rounded-lg focus:outline-none border ${placeholderStyle}`
  //   const hovered = 'enabled:hover:border-primary-gray-950'
  //   const focused = 'focus:border-primary-gray-950 focus-within:text-primary-gray-950 '
  //   const disabledStyles = 'disabled:hover:border-primary-gray-300'
  //
  //
  //   return `${defaultStyles} ${hovered} ${disabledStyles} ${focused} pl-[44px]`
  //
  // }
  // Was a hand-rolled 22x25 glyph at strokeWidth 2 with #667085 baked in, so it
  // matched neither the icon scale nor the theme. Lucide at 18, inheriting colour.
  const CalendarIcon = () => <LuCalendar size={18} className="text-text-secondary" />
  return (
    <div className={parentClassName}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        {/* Was DemoItem from @mui/x-date-pickers/internals/demo — a documentation-only
            component that wraps its child in a MUI Stack. The Stack's child spacing
            added 8px on top of the label's own mb-2, so a Date field sat 8px lower
            than the Input or Dropdown beside it (measured 16px gap against their 8px).
            A plain wrapper leaves inputAndLabelDistance as the single source. */}
        <div className="flex flex-col">
          {withLabel && (
            <div className={`${inputAndLabelDistance} flex justify-start flex-col text-[13px] leading-5 ${hasError ? "text-primary-static-error-600" : "text-text-secondary"}`}>
              {label}
            </div>
          )}
          <DatePicker
            label={false}
            disabled={disabled}
            isRequired={isRequired}
            className={`calendar ${width}`}
            value={optional ? (value ? dayjs(value) : null) : dayjs(value)}
            onChange={(newValue) => onChange(newValue)}
            format="MM-DD-YYYY"
            disablePast={disablePast}
            disableFuture={disableFuture}
            slots={{ openPickerIcon: CalendarIcon }}
            slotProps={{ popper: { disablePortal: true } }}
            timezone={timezone}
            shouldDisableDate={(date) => weekendsDisabled && (
              date.isSame(dayjs(), 'day') ||
              date.day() === 0 ||
              date.day() === 6
            )}
            sx={{
              '& > div': {
                height: height ? height : "56px",
                width: calendarWidth,
                borderRadius: '8px !important'
              },
              'fieldset': {
                top: 0,
                border: '1px solid',
                // Without an explicit height the outlined fieldset renders 5px
                // taller than its own input, so date fields sat proud of the
                // text inputs and selects beside them.
                height: height ? height : '56px',
                borderColor: hasError ? '#F04438' : 'var(--color-divider)',
                '--tw-border-opacity': '1',
                'legend': {
                  display: 'none'
                }
              }
            }}
          />

        </div>

      </LocalizationProvider>

      {hasError && <p className="text-primary-static-error-600 text-sm mt-1">{errorMsg}</p>}

    </div>
  )
}

export default Calendar
